import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import VenueDetail from "./pages/VenueDetail";
import Contact from "./pages/Contact";
import Auth from "./pages/Auth";
import CreateReview from "./pages/CreateReview";
import Dashboard from "./pages/Dashboard";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminAdmins from "./pages/admin/AdminAdmins";
import AdminVenues from "./pages/admin/AdminVenues";
import AdminVenueEdit from "./pages/admin/AdminVenueEdit";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminReviewEdit from "./pages/admin/AdminReviewEdit";
import AdminSeo from "./pages/admin/AdminSeo";
import AdminCities from "./pages/admin/AdminCities";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import { AdminRoute } from "./components/admin/AdminRoute";
import CityVenues from "./pages/CityVenues";
import NotFound from "./pages/NotFound";
import AccountSummary from "./pages/account/AccountSummary";
import AccountReviews from "./pages/account/AccountReviews";
import AccountReviewDetail from "./pages/account/AccountReviewDetail";
import AccountProfile from "./pages/account/AccountProfile";
import EditReview from "./pages/account/EditReview";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/salas/:city" element={<CityVenues />} />
            <Route path="/sala/:slug" element={<VenueDetail />} />
            <Route path="/sala/:slug/review" element={<CreateReview />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/mi-cuenta" element={<AccountSummary />} />
            <Route path="/mi-cuenta/reviews" element={<AccountReviews />} />
            <Route path="/mi-cuenta/reviews/:id" element={<AccountReviewDetail />} />
            <Route path="/mi-cuenta/reviews/:id/editar" element={<EditReview />} />
            <Route path="/mi-cuenta/perfil" element={<AccountProfile />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/admins" element={<AdminRoute><AdminAdmins /></AdminRoute>} />
            <Route path="/admin/venues" element={<AdminRoute><AdminVenues /></AdminRoute>} />
            <Route path="/admin/venues/new" element={<AdminRoute><AdminVenueEdit /></AdminRoute>} />
            <Route path="/admin/venues/:id/edit" element={<AdminRoute><AdminVenueEdit /></AdminRoute>} />
            <Route path="/admin/reviews" element={<AdminRoute><AdminReviews /></AdminRoute>} />
            <Route path="/admin/reviews/:id/edit" element={<AdminRoute><AdminReviewEdit /></AdminRoute>} />
            <Route path="/admin/seo" element={<AdminRoute><AdminSeo /></AdminRoute>} />
            <Route path="/admin/cities" element={<AdminRoute><AdminCities /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/admin/users/:id" element={<AdminRoute><AdminUserDetail /></AdminRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
